export const FORGOT_PASSWORD_CLEAR = 'FORGOT_PASSWORD_CLEAR';
export const FORGOT_PASSWORD_CLEAR_ERROR = 'FORGOT_PASSWORD_CLEAR_ERROR';
export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_FINISH = 'FORGOT_PASSWORD_FINISH';
